class AimeveProductGalleryNavigation {
  constructor(gallery) {
    this.gallery = gallery;
    this.items = Array.from(gallery.querySelectorAll('.product__media-list > .product__media-item[data-media-id]'));
    this.previous = gallery.querySelector('[data-aimeve-gallery-prev]');
    this.next = gallery.querySelector('[data-aimeve-gallery-next]');

    if (this.items.length < 2 || !this.previous || !this.next) return;

    this.previous.addEventListener('click', (event) => this.move(event, -1));
    this.next.addEventListener('click', (event) => this.move(event, 1));
  }

  move(event, direction) {
    event.preventDefault();
    event.stopPropagation();

    const activeIndex = this.items.findIndex((item) => item.classList.contains('is-active'));
    const currentIndex = activeIndex >= 0 ? activeIndex : 0;
    const nextIndex = (currentIndex + direction + this.items.length) % this.items.length;
    const target = this.items[nextIndex];

    if (typeof this.gallery.setActiveMedia === 'function') {
      this.gallery.setActiveMedia(target.dataset.mediaId, false);
    }
  }
}

const initializeAimeveProductGalleries = (scope = document) => {
  scope.querySelectorAll('media-gallery').forEach((gallery) => {
    if (gallery.dataset.aimeveNavigationInitialized === 'true') return;
    gallery.dataset.aimeveNavigationInitialized = 'true';
    new AimeveProductGalleryNavigation(gallery);
  });
};

document.addEventListener('DOMContentLoaded', () => initializeAimeveProductGalleries());
document.addEventListener('shopify:section:load', (event) => initializeAimeveProductGalleries(event.target));
